import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/providers.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.11_@babel+core@7.28.5_@playwright+test@1.58.1_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/.pnpm/sonner@1.7.4_react-dom@18.3.1_react@18.3.1/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.css");
